import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import { Interactions } from './interactions';
import * as Styled from './page-top-bar.style';

export type PageTopBarProps = {
  showHabits: boolean;
  onToggleShowHabits: () => void;
};

export const PageTopBar: React.FC<PageTopBarProps> = ({
  showHabits,
  onToggleShowHabits,
}) => {
  const { t } = useTranslation();

  return (
    <TopBarBase>
      <Styled.Content>
        <Styled.Title>
          <Typography variant="h5" component="h1">
            {t('pages.completed.title')}
          </Typography>
        </Styled.Title>

        <Interactions
          showHabits={showHabits}
          onToggleShowHabits={onToggleShowHabits}
        />
      </Styled.Content>
    </TopBarBase>
  );
};
